import React from 'react'
import {
  Button,
  ListItem,
  ListItemAvatar,
  ListItemText,
  Typography,
  Grid,
  Divider
} from '@material-ui/core'
import { makeStyles, useTheme } from '@material-ui/core/styles'

import Thumb from '~/components/Thumb'
import { useLiterals } from '~/components/Literals'
import useViewportSize from '~/components/useViewportSize'

import api from '~/api'
import track from '~/track'
import { formatName } from '~/utils'

const useStyles = makeStyles((theme) => ({
  listItem: {
    paddingBlock: 24
  },
  itemAvatar: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    height: 60
  },
  itemPrice: {
    fontSize: 20,
    fontWeight: 500,
    color: '#000'
  },
  textButton: {
    color: theme.palette.primary.contrastText,
    width: 125,
    '& p::first-letter': { textTransform: 'uppercase' },
    '&:hover': { color: theme.palette.primary.contrastText }
  }
}))

const IMG_PUBLIC_REPO = 'https://s3.sa-east-1.amazonaws.com/gofind.img.repo/onlinestore'

export function trackApi(data, product, store, config, position) {
  api.clickTrack({
    gtin: product && (product.gtin || product[0].gtin),
    productName: product && (product.name || product[0].name),
    name: store && store.name ? store.name : 'all',
    cnpj: store && store.cnpj ? store.cnpj : '00000000000000',
    brand: config.isOndetem ? product.brand : null,
    user: position?.user,
    ...data
  })
}

export default function ItemEcommerce({
  store,
  product,
  showValue,
  divider,
  handleLogger,
  isManually
}) {
  const classes = useStyles()
  const theme = useTheme()
  const viewport = useViewportSize()
  const { getLiteral } = useLiterals()

  const isMobile = viewport.width < theme.gofind.desktopMaxWidth
  const srcImage = `${IMG_PUBLIC_REPO}/${formatName(store.name)}`
  const altImage = `${store.name}-logo`

  const handleClick = (store, product, isManually) => {
    handleLogger(store)

    isManually &&
      track('storeOnline', {
        name: store.name,
        category: 'LojasOnline'
      })
    !isManually &&
      track('cliqueLojaOnline', {
        name: store.name,
        category: 'LojasOnline'
      })

    track('verLojaOnline', { name: product.name, category: 'LojasOnline' })
  }

  const formatPrice = (value) => {
    return new Intl.NumberFormat('pt-br', {
      style: 'currency',
      currency: 'BRL',
      minimumFractionDigits: 2
    }).format(value)
  }

  return (
    <Grid>
      <ListItem className={classes.listItem}>
        <Grid className={classes.itemAvatar}>
          <ListItemAvatar style={{ textAlign: 'center' }}>
            <Thumb
              src={srcImage}
              alt={altImage}
              style={{ width: 70 }}
              RenderError={() => {
                const storeNameSplited = store.name.split(' ')

                return (
                  <ListItemText
                    style={{ padding: '8px 16px 8px 8px' }}
                    primary={
                      isMobile ? (
                        storeNameSplited?.map((name, index, arr) => (
                          <>
                            <Typography
                              key={`${name}-${index}`}
                              component="span"
                              style={{ fontWeight: 600 }}
                            >
                              {name}
                            </Typography>
                            {index !== arr.length - 1 && <br />}
                          </>
                        ))
                      ) : (
                        <Typography component="span" style={{ fontSize: 14, fontWeight: 600 }}>
                          {store.name}
                        </Typography>
                      )
                    }
                  />
                )
              }}
            />
          </ListItemAvatar>
        </Grid>

        {showValue ? (
          <ListItemText
            style={{ flex: 1, alignItems: 'center' }}
            primary={
              <Typography component="span" className={classes.itemPrice}>
                {formatPrice(store.price)}
              </Typography>
            }
          />
        ) : null}

        <Button
          href={store.url}
          disableElevation
          target="_blank"
          component="a"
          variant="contained"
          color="primary"
          onClick={() => handleClick(store, product, isManually)}
          className={classes.textButton}
        >
          {isManually ? getLiteral('2393') : getLiteral('2394')}
        </Button>
      </ListItem>

      {divider && <Divider variant="middle" component="li" style={{ backgroundColor: '#EEE' }} />}
    </Grid>
  )
}
